import * as React from "react";
import { useSelector } from "react-redux";
import { SliderSection } from "../Components/SliderSection";
import { Features } from "../Components/Features";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Enamad } from "../Components/Enamad/Enamad";
import CustomModal from "../Components/CustomModal";
import Helmet from "../Components/Helment";
import ProductSlider from "../Components/ProductSlider";

const Home = () => {
  const authState = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();

  if (!authState?.isLoggedIn) {
    if (searchParams.get("rt")) {
      Cookies.set("rt", searchParams.get("rt"), { expires: 30 });
    }
  }

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <Helmet title='خانه'>
      <div className="container mt-2">
        <CustomModal isOpen={isModalOpen} closeModal={closeModal} />
        {/* {isModalOpen && (
        )} */}
        <div className="container  ">
          {authState?.isLoggedIn ? (
            ""
          ) : (
            <div id="alerts">
              <div
                dir="rtl"
                className="alert mt-2 shadow alert-primary alert-dismissible fade show text-center"
                role="alert"
              >
                شما کاربر مهمان می باشید{" "}
                <b
                  data-bs-toggle="modal"
                  data-bs-target="#ModalLogin"
                  className="alert-link"
                >
                  {" "}
                  با عضویت در تاب سی درامد زایی کنید و بیمه هدیه بگیرید{" "}
                </b>
                <b className="text-danger">
                  {" "}
                  (<h4 className="d-inline">63% </h4> تخفیف ویژه بیمه نامه)
                </b>
                <button
                  className=" m-2 btn btn-primary"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setIsModalOpen(true)}
                >
                  عضویت در تاب 30
                </button>
              </div>
            </div>
          )}
          <SliderSection />
        </div>
        <Features />
        <ProductSlider/>
        <Enamad />
      </div>
    </Helmet>
  );
};

export default Home;
